var map = {
	"./01_rooms-student-room.1024.jpg": 8366,
	"./01_rooms-student-room.1024.webp": 8060,
	"./01_rooms-student-room.1280.jpg": 8666,
	"./01_rooms-student-room.1280.webp": 6300,
	"./01_rooms-student-room.1536.jpg": 1678,
	"./01_rooms-student-room.1536.webp": 328,
	"./01_rooms-student-room.640.jpg": 245,
	"./01_rooms-student-room.640.webp": 3371,
	"./01_rooms-student-room.768.jpg": 2874,
	"./01_rooms-student-room.768.webp": 3534,
	"./01_rooms-student-room.original.jpg": 2830,
	"./01_rooms-student-room.original.webp": 1016,
	"./01_rooms-student-room.thumbnail.jpg": 1675,
	"./02_rooms-student-room-full.mp4": 9789
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7474;